module.exports = __webpack_public_path__ + "static/media/image.208cbf15.jpg";